<template>
  <v-container pa-0>
    <div class="v-label mb-2">{{ label }}:</div>

    <file-upload-dnd
      multiple
      class="mx-auto"
      :dropzone-options="dropzoneOptions"
      :title="`Upload ${label}`"
      :disabled="disabled"
      v-model="question.value"
      :rules="[!required || requiredRule]"
    >
    </file-upload-dnd>
  </v-container>
</template>
<script>
import FileUploadDnd from "@/components/FileUploadDnd";
import QuestionMixin from "@/components/question/QuestionMixin.js";

export default {
  name: "FileUploadQuestion",
  mixins: [QuestionMixin],
  components: {
    FileUploadDnd
  },
  data: function() {
    return {
      requiredRule: val =>
        (!!val && val.length > 0) || "A file is required to be uploaded",
      dropzoneOptions: {
        url: "/services/files",
        headers: {
          "user-type": "client",
          "data-point-id": this.question.dataPointId,
          "directory-name": "evd"
        },
        params: {
          // 3 mode are supported:
          // - overwrite(default if not specify): overwrite existing file with same name
          // - unique: rename file with unique suffix if existing file with same name found
          // - exclusive: error out letting the user know if existing file with same name found
          mode: "unique"
        }
      }
    };
  }
};
</script>
